import { render, staticRenderFns } from "./d2-container-full.vue?vue&type=template&id=63560c4f"
import script from "./d2-container-full.vue?vue&type=script&lang=js"
export * from "./d2-container-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@2.0.1_css-loader@1.0.1_lodash@4.17.23_vue-t_23eqhx62sqp34qe7sda26fp75m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./d2-container-full.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports